export const QA_PARENT_EMAILS = new Set(["parent.beta@heirwise.app"]);
export const QA_CHILD_EMAILS = new Set(["teen.beta@heirwise.app"]);

export function normalizeEmail(email?: string | null): string {
  return (email || "").trim().toLowerCase();
}

export function isKnownParentEmail(email?: string | null): boolean {
  return QA_PARENT_EMAILS.has(normalizeEmail(email));
}

export function isKnownChildEmail(email?: string | null): boolean {
  return QA_CHILD_EMAILS.has(normalizeEmail(email));
}

/**
 * Disposable QA / internal test identities. Used to flag analytics traffic so
 * test sessions can be excluded from production product analytics. This never
 * transmits the email itself — only the resulting boolean.
 */
const QA_EMAIL_DOMAINS = ["heirwisetest.com"];

export function isTestAccountEmail(email?: string | null): boolean {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;
  if (isKnownParentEmail(normalized) || isKnownChildEmail(normalized)) return true;
  const domain = normalized.split("@")[1] ?? "";
  if (QA_EMAIL_DOMAINS.includes(domain)) return true;
  return normalized.startsWith("qa.") || normalized.startsWith("qa+");
}

export function roleFromKnownQaEmail(email?: string | null): "parent" | "child" | null {
  if (isKnownParentEmail(email)) return "parent";
  if (isKnownChildEmail(email)) return "child";
  return null;
}